import { useState, useEffect } from 'react';

interface useTrackImpressionEventProps {
    shouldTrack: boolean;
    onTrack: () => void;
}

export function useTrackImpressionEvent({
  shouldTrack,
  onTrack
}: useTrackImpressionEventProps) {
  const [hasSeenComponent, setHasSeenComponent] = useState<boolean>(false);

  useEffect(() => {
    const handleTrackEvent = () => {
      if (shouldTrack && !hasSeenComponent) {
        onTrack();
        setHasSeenComponent(true);
      }
    };

    handleTrackEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldTrack]);
}